import UltMeta, { Meta } from "./UltMeta/index";

class State extends UltMeta {
    NOT_CONFIRMED = new Meta(1, "未确认");
    CONFIRMED = new Meta(2, "已确认");
    REJECTED = new Meta(3, "已拒绝");
}
export const STATE = new State();

// 激活状态
class ActiveState extends UltMeta {
    EXPIRE = new Meta(0, "已失效");
    ACTIVE = new Meta(1, "已激活");
}
export const ACTIVE_STATE: ActiveState = new ActiveState();

class DeleteType extends UltMeta {
    DELETE_RECORD = new Meta(1, "删除关联关系");
    DELETE_ACCOUNT = new Meta(2, "删除子账号");
}
export const DELETE_TYPE = new DeleteType();

class SearchType extends UltMeta {
    MAIN_ACCOUNT = new Meta(1, "查询主账号");
    SUB_ACCOUNT = new Meta(2, "查询子账号");
}
export const SEARCH_TYPE = new SearchType();
